// Common chrome for authenticated portal pages (VII-207).

import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { AppBar, Box, Button, Toolbar, Typography } from '@mui/material';
import portalApi from './api';
import { clearPortalSession, getPortalEmail } from './auth';

export default function PortalLayout() {
  const navigate = useNavigate();
  const email = getPortalEmail();

  const handleLogout = async () => {
    try { await portalApi.post('/portal/auth/logout'); } catch { /* ignore */ }
    clearPortalSession();
    navigate('/portal/login', { replace: true });
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', bgcolor: 'background.default' }}>
      <AppBar position="static" color="default" elevation={1}>
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1, cursor: 'pointer' }} onClick={() => navigate('/portal/tickets')}>
            Viilu Support
          </Typography>
          {email && (
            <Typography variant="body2" color="text.secondary" sx={{ mr: 2 }}>
              {email}
            </Typography>
          )}
          <Button onClick={handleLogout} size="small">Sign out</Button>
        </Toolbar>
      </AppBar>
      <Box component="main" sx={{ flex: 1, p: 3, maxWidth: 1200, mx: 'auto', width: '100%' }}>
        <Outlet />
      </Box>
    </Box>
  );
}
